import React, { useContext, useState } from "react";
import FormDataContext from "integrations/contexts/FormDataContext";
import Select from "components/common/Select";
import { Input } from "components/bootstrap";
import FormAdvancedOptions from "./FormAdvancedOptions";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { formData } = useContext(FormDataContext);
  const [formError] = useState(null);
  const { pollingInterval } = formData;
  const availableLog = [
    { label: "VPC Flow", value: "VPC_FLOW_LOGS" },
    { label: "Firewall", value: "FIREWALL_LOGS" },
    { label: "Audit Data Access", value: "AUDIT_LOGS_DATA_ACCESS" },
    { label: "Audit Activity", value: "AUDIT_LOGS_ACTIVITY" },
    { label: "Audit System Event", value: "AUDIT_LOGS_SYSTEM_EVENT" },
    { label: "Audit Policy Denied", value: "AUDIT_LOGS_POLICY_DENIED" }
  ];
  const [logTypes, setLogTypes] = useState("");
  const [logTypeVal, setLogTypeVal] = useState(false);
  const handleSubmit = () => {
    if (logTypes.length === 0) {
      setLogTypeVal(true);
      return;
    }
    formData.logs.value = logTypes;
    onSubmit();
  };
  return /* @__PURE__ */ React.createElement(FormWrap, { onSubmit: handleSubmit, buttonContent: "Proceed", title: "", error: formError, description: "" }, /* @__PURE__ */ React.createElement("label", { className: "control-label", htmlFor: "logs" }, "Logs Types to Collect"), /* @__PURE__ */ React.createElement(
    Select,
    {
      multi: true,
      name: "logs",
      id: "logs",
      onChange: (selected) => {
        setLogTypes(selected);
        setLogTypeVal(false);
      },
      options: availableLog,
      value: logTypes
    }
  ), logTypeVal && logTypes.length === 0 && /* @__PURE__ */ React.createElement("label", { htmlFor: "pollingInterval" }, "Select at least one"), /* @__PURE__ */ React.createElement("span", { className: "help-block" }, "The activity log for the above log types will be fetched."), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pollingInterval",
      type: "number",
      value: pollingInterval.value || pollingInterval.defaultValue,
      min: "5",
      max: "60",
      onChange,
      required: true,
      help: "Determines how often (in minutes) the input will check for new data from GCP. The smallest allowable interval is 5 minute.",
      label: "Polling Interval"
    }
  ), /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange }));
};
export default StepSubscribe;
